import { useRef, MutableRefObject } from 'react';
import {
  Drawer,
  MLPVersion,
  CardRadioButton,
  useTranslation,
  FAIcon,
  IconStyle,
  Theme,
  useMasterData,
} from '@nextgen-web-framework/all';
import { Config } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';
import type { LanguageModalProps } from './types/propTypes';
import styles from './LanguageModal.module.scss';

const LanguageModal = ({ onClose, currentLocale, languageHandler, hasBackButton = false }: LanguageModalProps) => {
  const t = useTranslation();
  const langRef = useRef() as MutableRefObject<HTMLDivElement>;
  const webShopConfigs = useMasterData<Config>('WebshopConfigs') as Config;
  return (
    <Drawer
      header={
        <div className={styles['drawer-header-container']}>
          {hasBackButton ? (
            <div className={styles['back-icon-container']} data-testid="language-back-button-test-id">
              <FAIcon iconName={'angle-left'} iconStyle={IconStyle.REGULAR} onClick={onClose} />
            </div>
          ) : (
            ''
          )}
          <div className={styles['lang-heading']}>{t('web.lang')}</div>{' '}
        </div>
      }
      closeIcon={!hasBackButton}
      closeOnBackdropClick={true}
      bottomGap={0}
      onClose={onClose}
      useReactPortal={true}
      portalContainerId={'react-portal-drawer'}
    >
      <div className={styles['language-modal-container']} ref={langRef} data-testid="language-modal-test-id">
        {webShopConfigs?.locales?.map((option) => (
          <CardRadioButton
            label={option.lang}
            key={option.lang}
            id={option.locale}
            name="radioVariant"
            data-testid={`card-radio-test-id-${option.locale}`}
            onClick={() => {
              languageHandler?.(option.locale);
            }}
            checked={option.locale === currentLocale}
            theme={option.locale === currentLocale ? Theme.PURPLE : Theme.BLACK}
            mlpVersion={MLPVersion.TWO}
          />
        ))}
      </div>
    </Drawer>
  );
};

export default LanguageModal;
